import { APP } from 'libs/constants';
import apiCall from './apiRequest';
import endPoints from './endpoints';
import config from 'config';

const { API } = config;

const MUSE_PLANS_CA = {
  plans: [
    {
      title: 'views.musePlans.planCardsWrapper.annual.CA.title',
      tax: null,
      planID: 'ca-muse-annual-125',
      currency: 'CAD',
      country: 'CA',
      offer: 'views.musePlans.planCardsWrapper.annual.CA.offer',
      isRecommended: true,
      isSelected: true,
      frequency: 'Annual',
      amount: 124.99
    },
    {
      title: 'views.musePlans.planCardsWrapper.monthly.CA.title',
      planID: 'ca-muse-monthly-17-49',
      currency: 'CAD',
      country: 'CA',
      isRecommended: false,
      isSelected: false,
      frequency: 'Monthly',
      amount: 17.49,
      tax: null
    }
  ]
};

const MUSE_PLANS_US = {
  plans: [
    {
      title: 'views.musePlans.planCardsWrapper.annual.US.title',
      tax: null,
      planID: 'us-muse-annual-95',
      currency: 'USD',
      country: 'US',
      offer: 'views.musePlans.planCardsWrapper.annual.US.offer',
      isRecommended: true,
      isSelected: true,
      frequency: 'Annual',
      amount: 94.99
    },
    {
      title: 'views.musePlans.planCardsWrapper.monthly.US.title',
      planID: 'us-muse-monthly-13',
      currency: 'USD',
      country: 'US',
      isRecommended: false,
      isSelected: false,
      frequency: 'Monthly',
      amount: 12.99,
      tax: null
    },
  ]
};

export function fetchMusePlansApi(countryCode) {
  let plansObj = MUSE_PLANS_US;
  if (countryCode && countryCode.toUpperCase() === 'CA') {
    plansObj = MUSE_PLANS_CA;
  }

  return Promise.resolve(plansObj);
}

export function checkoutMusePlanApi(plan, nonTrial, locale) {
  return apiCall({
    method: 'put',
    endpoint: endPoints.planCheckout,
    payload: {
      app: APP.muse,
      plan,
      non_trial: nonTrial
    },
    query: {
      locale
    }
  });
}

export function fetchPlanCurrencyApi(activationCode) {
  return apiCall({
    method: 'get',
    url: `${API.fastApi}/${endPoints.planCurrency}`,
    query: {
      coupon: activationCode
    }
  });
}

export default {
  fetchMusePlansApi
};



// WEBPACK FOOTER //
// ./src/api/musePlans.js